// extracted by mini-css-extract-plugin
export default {"clientPicker":"ClientPicker_clientPicker__o2itA"};